module.exports = __webpack_public_path__ + "static/card-image1-5e2f60b9e897f5a8cf68e6b22a86e7a6.png";